import { render, staticRenderFns } from "./UserSetup.vue?vue&type=template&id=afada29c&"
import script from "./UserSetup.vue?vue&type=script&lang=js&"
export * from "./UserSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports